module.exports = __webpack_public_path__ + "images/1d04937.png";